const API_BASE = process.env.REACT_APP_WOW_SIGN_API_BASE_URL;

export function createDocumentEventSource(documentId) {
  return new EventSource(`${API_BASE}/stream/documents/${documentId}`);
}

export function createSignerEventSource(accessToken) {
  return new EventSource(`${API_BASE}/stream/signer/${accessToken}`);
}

export function createNotificationEventSource() {
  return new EventSource(`${API_BASE}/stream/notifications`);
}
